import { entity_types } from '../data/data';

export default {
    items: [
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'name',
                    width: 8,
                    props: {
                        label: 'OBA Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'ownership',
                    width: 4,
                    props: {
                        format: 'percent',
                        label: 'Ownership %'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'selectlist',
                    name: 'entity-type',
                    width: 8,
                    props: {
                        label: 'Entity',
                        items: entity_types
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'radio-list',
                    name: 'included',
                    width: 8,
                    props: {
                        label: 'Included in Valuation?',
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    }
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/data_table_forms/oba.js